/*eslint-disable*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Select,
  Row,
  Popconfirm,
  message,
} from "antd";
import { DeleteFilled, EditTwoTone, SearchOutlined } from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  getUsers,
  createUser,
  deleteUser,
} from "../Actions/usersAction";
import MyTable from "../components/table";
import "./styles/clients.css";
import { UpdateEmployeeUser } from "./updateEmployeeUser";
import { ManagePermissionsModal } from "../components/ManagePermissionsModal";
import { debounce } from "lodash";
import useResizeObserver from "../components/useResizeObserver";
import useColumnSearch from "../Utils/useColumnSearch";

const Role = [
  { value: 0, label: "Admin" },
  { value: 1, label: "Employee" },
];
// const phoneRegExp = /^[0][1-9]\d{9}$|^[1-9]\d{9}$/;
const schema = Yup.object().shape({
  first_name: Yup.string().required("Required"),
  last_name: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
});
// const { TextArea } = Input;
const { Text, Title } = Typography;

const EmployeeUsers = ({ currentUser }) => {
  const dispatch = useDispatch();
  const {
    users,
    isGetUsersLoading,
    isCreateUserLoading,
    isUpdateUserLoading,
    isDeleteUserLoading,
  } = useSelector((state) => state.users);
  useEffect(() => {
    dispatch(getUsers());
  }, []);

  const { register, handleSubmit, errors, control, reset } = useForm({
    resolver: yupResolver(schema),
  });
  const [createDialog, setCreateDialog] = useState(false);
  const [error, setError] = useState();

  const handleCreateUser = (data, event) => {
    // event.preventDefault();
    dispatch(createUser(data, successCreateUser, failureCreateUser));
  };

  const successCreateUser = () => {
    setCreateDialog(false);
    dispatch(getUsers());
    reset();
    setTimeout(() => {
      message.success("You have successfully created user.");
    }, 2000);
  };

  const failureCreateUser = (res) => {
    setTimeout(() => {
      message.info(res?.response?.data?.email);
    }, 2000);
    setCreateDialog(false);
    reset();
  };
  const handleCancel = () => {
    setCreateDialog(false);
    reset();
  };

  return (
    <Spin
      spinning={
        isGetUsersLoading || isUpdateUserLoading || isDeleteUserLoading
      }
    >
      {/* <Button type="text" onClick={() => setCreateDialog(true)} style={{ fontWeight: 500, color: '#1890ff' }}>Create User</Button> */}
      <Modal
        title="Create User"
        visible={createDialog}
        onCancel={() => handleCancel()}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={isCreateUserLoading}>
          <form onSubmit={handleSubmit(handleCreateUser)}>
            <Row>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>First Name</Text>
                  <Controller
                    as={Input}
                    name="first_name"
                    control={control}
                    placeholder="First Name"
                    style={{ width: 200 }}
                  />
                  {errors.first_name && (
                    <span className="error_style">First Name is required</span>
                  )}
                </Space>
              </Col>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>Last Name</Text>
                  <Controller
                    as={Input}
                    name="last_name"
                    control={control}
                    placeholder="Last Name"
                    style={{ width: 200 }}
                  />
                  {errors.last_name && (
                    <span className="error_style">Last Name is required</span>
                  )}
                </Space>
              </Col>
            </Row>
            <Row>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>E-mail</Text>
                  <Controller
                    as={Input}
                    name="email"
                    control={control}
                    placeholder="E-mail"
                    style={{ width: 200 }}
                  />
                  {errors.email && (
                    <span className="error_style">E-mail is required</span>
                  )}
                </Space>
              </Col>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Space direction="vertical" className="create_client_field">
                  <Text>Role Type</Text>
                  <Controller
                    as={Select}
                    control={control}
                    options={Role}
                    style={{ width: 200 }}
                    name="role"
                  />
                  {errors.role && (
                    <span className="error_style">Role Type is required</span>
                  )}
                </Space>
              </Col>
            </Row>
            <Col className="notes_box">
              <Button
                type="primary"
                htmlType="submit"
                block
                style={{ top: 10 }}
              >
                Create User
              </Button>
            </Col>
          </form>
        </Spin>
      </Modal>
      <Col className="notes_box"></Col>
      {users && (
        <AllEmployeeUsers
          data={users}
          handleDialog={() => setCreateDialog(true)}
          currentUser={currentUser}
        />
      )}
    </Spin>
  );
};
export default EmployeeUsers;

const AllEmployeeUsers = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const [CurrentEmployeeUser, setCurrentEmployeeUser] = useState({});
  const { handleDialog, currentUser } = props;
  const [size, setSize] = useState({ width: 0, height: 0 });

  const dispatch = useDispatch();
  const onRowSelect = (record) => {
    setCurrentEmployeeUser(record);
  };

  const columns = [
    {
      title: "First Name",
      width: 100,
      dataIndex: "first_name",
      key: "1",
      fixed: "left",
      ...getColumnSearchProps("first_name"),
    },
    {
      title: "Last Name",
      width: 100,
      dataIndex: "last_name",
      key: "2",
      // fixed: 'left',
      ...getColumnSearchProps("last_name"),
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "3",
      width: 150,
    },
    {
      title: "Role Type",
      dataIndex: "role",
      key: "4",
      width: 100,
    },
    {
      title: "id",
      width: 100,
      dataIndex: "id",
      key: "5",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id, record) => <ActionComponent id={id} userRecord={record} currentUser={currentUser} />,
    },
  ];

  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== size.width || newHeight !== size.height) {
        setSize({ width: newWidth, height: newHeight });
      }
    }, 200),
    [size]
  );
  useResizeObserver(handleResize);

  return (
    <>
      {/* <Title level={4} className='title_all_clients'>All Users</Title> */}
      <Row className="rowWithPadding" justify="space-between">
        <Col xs={24} sm={24} md={12} lg={16} xl={16}>
          <Title level={4}>All Users({props.data.length})</Title>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Row justify="end" gutter={[5, 5]}>
            <Col>
              <Button type="primary" onClick={() => handleDialog()}>
                Create User
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <MyTable
            columns={columns}
            data={props.data}
            onRowSelect={(record) => onRowSelect(record)}
          />
        </Col>
      </Row>
    </>
  );
};

const ActionComponent = ({ id, userRecord, currentUser }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const handleDeleteUser = (user_id) => {
    dispatch(deleteUser(user_id, successDeleteUser, failureDeleteUser));
  };
  const successDeleteUser = () => {
    setTimeout(() => {
      message.success("You have successfully deleted user.");
    }, 2000);
    dispatch(getUsers());
  };
  const failureDeleteUser = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
  };

  const content = (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <UpdateEmployeeUser id={id} setPopoverVisible={setPopoverVisible} />
      {currentUser?.role === "Admin" && userRecord?.role === "Employee" && (
        <Button
          type="link"
          style={{ padding: "4px 15px", textAlign: "left", width: "100%" }}
          onClick={() => {
            setPopoverVisible(false);
            setPermissionsModalOpen(true);
          }}
        >
          Permissions
        </Button>
      )}
      {currentUser?.id === id ? (
        ""
      ) : (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDeleteUser(id)}
        >
          <Button type="link" danger style={{ padding: "4px 15px", textAlign: "left", width: "100%" }} onClick={() => setPopoverVisible(false)}>
            Delete
          </Button>
        </Popconfirm>
      )}
    </div>
  );
  return (
    <>
      <Popover content={content} open={popoverVisible} trigger="click" onOpenChange={setPopoverVisible}>
        <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
          Action
        </Button>
      </Popover>
      <ManagePermissionsModal
        visible={permissionsModalOpen}
        onClose={() => setPermissionsModalOpen(false)}
        userId={id}
        userName={`${userRecord?.first_name || ""} ${userRecord?.last_name || ""}`}
        userEmail={userRecord?.email || ""}
      />
    </>
  );
};
